<template>
  <div class="message_origin_area" v-if="displayMessageOrigin">
    <div class="name">
      <template v-if="messageOrigin.isImage">
        <img :src="messageOrigin.icon" :alt="messageOrigin.name" class="sourceImg" />
        <span>{{ messageOrigin.name }}</span>
      </template>
      <span v-else>{{ messageOrigin.icon }} {{ messageOrigin.name }}</span>
    </div>
  </div>
</template>

<script>
import moengageLogo from '@/resources/images/moengage.png';
import salesforceLogo from '@/resources/images/salesforce.png';
import salesforceApiLogo from '@/resources/images/salesforce_logo.svg';
import apigeeLogo from '@/resources/images/apigee.png';
import postmanLogo from '@/resources/images/postman.png';
import apiConnectorLogo from '@/resources/images/api-connector.svg';

export default {
  props: {
    sourceMessage: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  data() {
    return {
      messageOriginsValues: {
        livechat: { icon: '🗨️', name: 'Live chat' },
        broadcast: { icon: '📢', name: 'Broadcast' },
        bot: { icon: '🤖', name: 'Bot' },
        other: { icon: '🌐', name: 'Other' },
        salesforce: { icon: salesforceLogo, name: 'Salesforce' },
        api_salesforce: { icon: salesforceApiLogo, name: 'Salesforce' },
        api_moengage: { icon: moengageLogo, name: 'MoEngage' },
        apigee: { icon: apigeeLogo, name: 'Apigee' },
        postman: { icon: postmanLogo, name: 'Postman' }
      }
    };
  },
  computed: {
    displayMessageOrigin() {
      return (
        this.sourceMessage?.message_origin &&
        this.sourceMessage?.message_origin !== 'None' &&
        this.sourceMessage?.message_origin !== ''
      );
    },
    messageOrigin() {
      const origin = this.sourceMessage?.message_origin;
      let originData = this.messageOriginsValues[origin];
      
      // Handle generic API origins (but not api_moengage)
      if (!originData && origin && origin.startsWith('api') && origin !== 'api_moengage') {
        originData = { icon: apiConnectorLogo, name: 'API Connector' };
      }
      
      // Fallback to 'other' if origin is not found in messageOriginsValues
      const fallbackData = originData || this.messageOriginsValues.other;
      
      // Check if it's an imported image (webpack resolved) or HTTP URL
      const isImage = fallbackData && (
        typeof fallbackData.icon === 'string' && (
          fallbackData.icon.startsWith('http') || 
          fallbackData.icon.startsWith('data:') ||
          fallbackData.icon.includes('.png') ||
          fallbackData.icon.includes('.jpg') ||
          fallbackData.icon.includes('.jpeg') ||
          fallbackData.icon.includes('.svg')
        )
      );
      
      if (isImage) {
        return { icon: fallbackData.icon, name: fallbackData.name, isImage: true };
      } else {
        return { icon: fallbackData.icon, name: fallbackData.name, isImage: false };
      }
    }
  },
  methods: {
    
  }
}
</script>

<style scoped>

.message_origin_area {
  width: auto;
  display: inline-block;
  padding: 2px 10px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  background-color: #EDEDED;
  margin-bottom: 10px;
}

.sourceImg{
  width: auto !important;
  height: 14px !important;
  vertical-align: middle;
  margin-right: 4px;
}

.message_origin_area .name{
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #242424;
}
</style>